import { createAsyncThunk } from "@reduxjs/toolkit";

import publisherAPI from "../../services/api/publisher";

export const emailPublish = createAsyncThunk("clip/emailPublish", async (payload) => {
  try {
    const response = await publisherAPI.emailPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    const errorMessage = error?.response?.data?.error?.message;
    const message = Array.isArray(errorMessage) ? errorMessage.join(", ") : errorMessage;
    const errorObj = { ...(error?.response?.data?.error || error), message };
    throw errorObj;
  }
});

export const listPublishes = createAsyncThunk(`publish/listPublishes`, async (payload, { signal }) => {
  try {
    const response = await publisherAPI.listPublishes(payload, payload.signal || signal);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const distinctListPublishes = createAsyncThunk(`publish/distinctListPublishes`, async (payload, { signal }) => {
  try {
    const response = await publisherAPI.distinctListPublishes(payload, payload.signal || signal);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const brightCovePublish = createAsyncThunk("clip/brightCovePublish", async (payload) => {
  try {
    const response = await publisherAPI.brightCovePublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data || error;
  }
});

export const createBrightCoveCredentials = createAsyncThunk("clip/createBrightCoveCredentials", async (payload) => {
  try {
    const response = await publisherAPI.createBrightCoveCredentials(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const cloudPublishV2 = createAsyncThunk(`publish/cloudPublishV2`, async (payload) => {
  try {
    const response = await publisherAPI.cloudPublishV2(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const emercePublish = createAsyncThunk("clip/brightCovePublish", async (payload) => {
  try {
    const response = await publisherAPI.emercePublish(payload);

    return { data: response?.data, error: null };
  } catch (error) {
    console.error(error);
    if (error?.response?.data?.statusCode === 400) {
      const { data, error: errorMessage } = error?.response?.data;

      return { data, error: errorMessage };
    }
    throw error;
  }
});

export const createEmerceCredentials = createAsyncThunk("clip/createEmerceCredentials", async (payload) => {
  try {
    const response = await publisherAPI.createEmerceCredentials(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getActiveEmerceCredentials = createAsyncThunk("clip/getActiveEmerceCredentials", async (payload) => {
  try {
    const response = await publisherAPI.getActiveEmerceCredentials(payload);

    return { data: response?.data?.data, error: null };
  } catch (error) {
    console.error(error);
    if (error?.response?.data?.statusCode === 400) {
      const { data, error: errorMessage } = error?.response?.data;

      return { data, error: errorMessage };
    }
    throw error;
  }
});

export const createStorifyMeCredentials = createAsyncThunk("clip/createStorifyMeCredentials", async (payload) => {
  try {
    const response = await publisherAPI.createStorifyMeCredentials(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getActiveStorifyMeCredentials = createAsyncThunk("clip/getActiveStorifyMeCredentials", async (payload) => {
  try {
    const response = await publisherAPI.getActiveStorifyMeCredentials(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const disconnectStorifyMeCredentials = createAsyncThunk(
  "clip/disconnectStorifyMeCredentials",
  async (payload) => {
    try {
      const response = await publisherAPI.disconnectStorifyMeCredentials(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const socialMediaBulkPublish = createAsyncThunk(`publish/socialMediaBulkPublish`, async (payload) => {
  try {
    const response = await publisherAPI.socialMediaBulkPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const retrySocialMediaBulkPublish = createAsyncThunk(`publish/retrySocialMediaBulkPublish`, async (payload) => {
  try {
    const response = await publisherAPI.retrySocialMediaBulkPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const getSlackWorkspaceList = createAsyncThunk("publish/getSlackWorkspaceList", async (payload) => {
  try {
    const response = await publisherAPI.getSlackWorkspaceList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const initiateSlackAuth = createAsyncThunk("publish/initiateSlackAuth", async (payload) => {
  try {
    const response = await publisherAPI.initiateSlackAuth(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const handleSlackCallback = createAsyncThunk("publish/handleSlackCallback", async (payload) => {
  try {
    const response = await publisherAPI.handleSlackCallback(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const disconnectSlackIntegration = createAsyncThunk("publish/disconnectSlackIntegration", async (payload) => {
  try {
    const response = await publisherAPI.disconnectSlackIntegration(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getSlackChannelsList = createAsyncThunk(
  "publish/getSlackChannelsList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await publisherAPI.getSlackChannelsList(payload);

      return response.data;
    } catch (error) {
      console.error(error);

      return rejectWithValue(error.response?.data || error);
    }
  },
);

export const getSlackUsersList = createAsyncThunk("publish/getSlackUsersList", async (payload) => {
  try {
    const response = await publisherAPI.getSlackUsersList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateSelectedSlackChannel = createAsyncThunk("publish/updateSelectedSlackChannel", async (payload) => {
  try {
    const response = await publisherAPI.updateSelectedSlackChannel(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const slackPublish = createAsyncThunk("publish/slackPublish", async (payload, { dispatch }) => {
  try {
    const response = await publisherAPI.slackPublish(payload);
    if (response.data.statusCode === 200 && payload?.payload?.contentId) {
      const publishesPayload = {
        append: true,
        payload: {
          page: 1,
          pageSize: 10,
          entityId: payload?.payload?.entityId,
          filters: {
            contentIds: [payload?.payload?.contentId],
            statuses: ["completed"],
          },
        },
      };

      dispatch(distinctListPublishes(publishesPayload));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

// Dropbox Integration API actions
export const getDropboxAccountsList = createAsyncThunk("publish/getDropboxAccountsList", async (payload) => {
  try {
    const response = await publisherAPI.getDropboxAccountsList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const initiateDropboxAuth = createAsyncThunk("publish/initiateDropboxAuth", async (payload) => {
  try {
    const response = await publisherAPI.initiateDropboxAuth(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const handleDropboxCallback = createAsyncThunk(
  "publish/handleDropboxCallback",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await publisherAPI.handleDropboxCallback(payload);

      return response.data;
    } catch (error) {
      console.error(error);

      return rejectWithValue(error.response.data);
    }
  },
);

export const disconnectDropboxIntegration = createAsyncThunk(
  "publish/disconnectDropboxIntegration",
  async (payload) => {
    try {
      const response = await publisherAPI.disconnectDropboxIntegration(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDropboxTeamFoldersList = createAsyncThunk("publish/getDropboxTeamFoldersList", async (payload) => {
  try {
    const response = await publisherAPI.getDropboxTeamFoldersList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateDropboxTeamFolderSelect = createAsyncThunk(
  "publish/updateDropboxTeamFolderSelect",
  async (payload) => {
    try {
      const response = await publisherAPI.updateDropboxTeamFolderSelect(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const dropboxPublish = createAsyncThunk("publish/dropboxPublish", async (payload) => {
  try {
    const response = await publisherAPI.dropboxPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

// DailyMotion Integration API actions
export const getDailyMotionProfiles = createAsyncThunk("publish/getDailyMotionProfiles", async (payload) => {
  try {
    const response = await publisherAPI.getDailyMotionProfiles(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const initiateDailyMotionAuth = createAsyncThunk("publish/initiateDailyMotionAuth", async (payload) => {
  try {
    const response = await publisherAPI.initiateDailyMotionAuth(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const handleDailyMotionCallback = createAsyncThunk(
  "publish/handleDailyMotionCallback",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await publisherAPI.handleDailyMotionCallback(payload);

      return response.data;
    } catch (error) {
      console.error(error);

      return rejectWithValue(error.response.data);
    }
  },
);

export const disconnectDailyMotionIntegration = createAsyncThunk(
  "publish/disconnectDailyMotionIntegration",
  async (payload) => {
    try {
      const response = await publisherAPI.disconnectDailyMotionIntegration(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const updateDailyMotionProfileSelect = createAsyncThunk(
  "publish/updateDailyMotionProfileSelect",
  async (payload) => {
    try {
      const response = await publisherAPI.updateDailyMotionProfileSelect(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const updateDailyMotionProfileDefault = createAsyncThunk(
  "publish/updateDailyMotionProfileDefault",
  async (payload) => {
    try {
      const response = await publisherAPI.updateDailyMotionProfileDefault(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDailyMotionCategories = createAsyncThunk("publish/getDailyMotionCategories", async (payload) => {
  try {
    const response = await publisherAPI.getDailyMotionCategories(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDailyMotionLanguages = createAsyncThunk("publish/getDailyMotionLanguages", async (payload) => {
  try {
    const response = await publisherAPI.getDailyMotionLanguages(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDailyMotionPlaylists = createAsyncThunk("publish/getDailyMotionPlaylists", async (payload) => {
  try {
    const response = await publisherAPI.getDailyMotionPlaylists(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const dailyMotionPublish = createAsyncThunk("publish/dailyMotionPublish", async (payload) => {
  try {
    const response = await publisherAPI.dailyMotionPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getPublishFiles = createAsyncThunk(`publish/getPublishFiles`, async (payload) => {
  try {
    const { data } = await publisherAPI.getPublishFiles(payload);

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

// Google Drive Integration API actions
export const getGoogleDriveAccountsList = createAsyncThunk("publish/getGoogleDriveAccountsList", async (payload) => {
  try {
    const response = await publisherAPI.getGoogleDriveAccountsList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createGoogleDriveCredentials = createAsyncThunk(
  "publish/createGoogleDriveCredentials",
  async (payload) => {
    try {
      const response = await publisherAPI.createGoogleDriveCredentials(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const disconnectGoogleDriveIntegration = createAsyncThunk(
  "publish/disconnectGoogleDriveIntegration",
  async (payload) => {
    try {
      const response = await publisherAPI.disconnectGoogleDriveIntegration(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getGoogleDriveFoldersList = createAsyncThunk("publish/getGoogleDriveFoldersList", async (payload) => {
  try {
    const response = await publisherAPI.getGoogleDriveFoldersList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateGoogleDriveDefaultFolder = createAsyncThunk(
  "publish/updateGoogleDriveDefaultFolder",
  async (payload) => {
    try {
      const response = await publisherAPI.updateGoogleDriveDefaultFolder(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getGoogleDrivePickerUrl = createAsyncThunk("publish/getGoogleDrivePickerUrl", async (payload) => {
  try {
    const response = await publisherAPI.getGoogleDrivePickerUrl(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const selectGoogleDriveFolders = createAsyncThunk("publish/selectGoogleDriveFolders", async (payload) => {
  try {
    const response = await publisherAPI.selectGoogleDriveFolders(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const googleDrivePublish = createAsyncThunk("publish/googleDrivePublish", async (payload) => {
  try {
    const response = await publisherAPI.googleDrivePublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

// Frame.io Integration API actions
export const getFrameIOCredentialsList = createAsyncThunk("publish/getFrameIOCredentialsList", async (payload) => {
  try {
    const response = await publisherAPI.getFrameIOCredentialsList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const initiateFrameIOAuth = createAsyncThunk("publish/initiateFrameIOAuth", async (payload) => {
  try {
    const response = await publisherAPI.initiateFrameIOAuth(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const handleFrameIOCallback = createAsyncThunk(
  "publish/handleFrameIOCallback",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await publisherAPI.handleFrameIOCallback(payload);

      return response.data;
    } catch (error) {
      console.error(error);

      return rejectWithValue(error.response.data);
    }
  },
);

export const disconnectFrameIOIntegration = createAsyncThunk(
  "publish/disconnectFrameIOIntegration",
  async (payload) => {
    try {
      const response = await publisherAPI.disconnectFrameIOIntegration(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getFrameIOAccounts = createAsyncThunk("publish/getFrameIOAccounts", async (payload) => {
  try {
    const response = await publisherAPI.getFrameIOAccounts(payload);

    return response.data;
  } catch (error) {
    if (error?.response?.data?.error?.message?.includes("expired")) {
      throw new Error("Your Frame.io session has expired. Please reconnect your Frame.io account to continue.");
    }

    throw error;
  }
});

export const getFrameIOAccountDetails = createAsyncThunk("publish/getFrameIOAccountDetails", async (payload) => {
  try {
    const response = await publisherAPI.getFrameIOAccountDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getFrameIOMe = createAsyncThunk("publish/getFrameIOMe", async (payload) => {
  try {
    const response = await publisherAPI.getFrameIOMe(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getFrameIOTeams = createAsyncThunk("publish/getFrameIOTeams", async (payload) => {
  try {
    const response = await publisherAPI.getFrameIOTeams(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getFrameIOProjects = createAsyncThunk("publish/getFrameIOProjects", async (payload) => {
  try {
    const response = await publisherAPI.getFrameIOProjects(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getFrameIOAssets = createAsyncThunk("publish/getFrameIOAssets", async (payload) => {
  try {
    const response = await publisherAPI.getFrameIOAssets(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const frameIOPublish = createAsyncThunk("publish/frameIOPublish", async (payload) => {
  try {
    const response = await publisherAPI.frameIOPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error?.message || error;
  }
});

export const frameIOBulkPublish = createAsyncThunk("publish/frameIOBulkPublish", async (payload) => {
  try {
    const response = await publisherAPI.frameIOBulkPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const refreshFrameIOToken = createAsyncThunk("publish/refreshFrameIOToken", async (payload) => {
  try {
    const response = await publisherAPI.refreshFrameIOToken(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

// Shade Integration Actions
export const getShadeAccountsList = createAsyncThunk("publish/getShadeAccountsList", async (payload) => {
  try {
    const response = await publisherAPI.getShadeAccountsList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const connectShadeAccount = createAsyncThunk("publish/connectShadeAccount", async (payload) => {
  try {
    const response = await publisherAPI.connectShadeAccount(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error?.message || error;
  }
});

export const disconnectShadeAccount = createAsyncThunk("publish/disconnectShadeAccount", async (payload) => {
  try {
    const response = await publisherAPI.disconnectShadeAccount(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error?.message || error;
  }
});

export const getShadeWorkspacesList = createAsyncThunk("publish/getShadeWorkspacesList", async (payload) => {
  try {
    const response = await publisherAPI.getShadeWorkspacesList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getShadeDrivesList = createAsyncThunk("publish/getShadeDrivesList", async (payload) => {
  try {
    const response = await publisherAPI.getShadeDrivesList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const shadePublish = createAsyncThunk("publish/shadePublish", async (payload, { rejectWithValue }) => {
  try {
    const response = await publisherAPI.shadePublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);

    return rejectWithValue(error.response?.data || error.message);
  }
});
